import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./xmas-promo-banner.module.css";
export function XmasPromoBanner() {
    return /*#__PURE__*/ _jsxs("p", {
        className: styles.text,
        children: [
            "Get your skates on and order by December 16 for Christmas delivery.",
            " ",
            /*#__PURE__*/ _jsx("a", {
                href: "/support#faq-christmas",
                className: styles.link,
                children: "View delivery FAQs"
            })
        ]
    });
}
export default XmasPromoBanner;
